import { Box, BoxProps } from '@chakra-ui/react';
import {
    faArrowUpRightFromSquare,
    faBars,
    faBoxOpen,
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faChartLine,
    faChartSimple,
    faChevronLeft,
    faChevronRight,
    faClipboardCheck,
    faClipboardList,
    faCog,
    faDownload,
    faEllipsisH,
    faEllipsisV,
    faEye,
    faHouseUser,
    faLanguage,
    faMap,
    faMoon,
    faPen,
    faRemove,
    faRotateRight,
    faSearch,
    faSignOut,
    faSliders,
    faSun,
    faSwatchbook,
    faTriangleExclamation,
    faTruck,
    faFileImport,
    faUpload,
    faUser,
    faUsersGear,
    faWrench,
    faXmark,
    faPhone,
    faCircleInfo,
    faBox,
    faEnvelope,
    faCircleUser,
    faBuilding,
    faArrowRight,
    faPause,
    faPlay,
    faCheck,
    faRoute,
    faComment,
    faChevronDown,
    faChevronUp,
    faMinus,
    faPlus,
    faRotate,
    faTag,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { forwardRef } from 'react';
import { productIcon } from './product-icons';

export const Icons = {
    Language: faLanguage,
    Logout: faSignOut,
    Worksite: faHouseUser,
    Order: faTruck,
    Task: faClipboardCheck,
    Dashboard: faChartLine,
    Chart: faChartSimple,
    Customer: faUser,
    Settings: faCog,
    Edit: faPen,
    Delete: faRemove,
    EllipsisH: faEllipsisH,
    EllipsisV: faEllipsisV,
    Warning: faTriangleExclamation,
    SwitchInstallation: faSwatchbook,
    Sun: faSun,
    Moon: faMoon,
    Close: faXmark,
    Search: faSearch,
    caretDown: faCaretDown,
    chevronLeft: faChevronLeft,
    chevronRight: faChevronRight,
    openLink: faArrowUpRightFromSquare,
    menu: faBars,
    upload: faUpload,
    download: faDownload,
    preview: faEye,
    reload: faRotateRight,
    map: faMap,
    phone: faPhone,
    Product: faBoxOpen,
    Resource: faWrench,
    Property: faSliders,
    Template: faClipboardList,
    Import: faFileImport,
    Info: faCircleInfo,
    UserManagement: faUsersGear,
    pause: faPause,
    play: faPlay,
    check: faCheck,
    route: faRoute,
    comment: faComment,
    chevronDown: faChevronDown,
    chevronUp: faChevronUp,
    minus: faMinus,
    plus: faPlus,
    recurring: faRotate,
    field: faTag,
    envelope: faEnvelope,
    user: faCircleUser,
    company: faBuilding,
    arrowRight: faArrowRight,
};

/** Icon for a product's stored icon name; generic box when none is set (task cards keep their counts aligned). */
export const productTaskIcon = (name: string | null | undefined) => productIcon(name) ?? faBox;

type IconProps = {
    icon: FontAwesomeIconProps['icon'];
    size?: FontAwesomeIconProps['size'];
} & BoxProps;

const Icon = forwardRef((props: IconProps, ref) => {
    return (
        <Box ref={ref} {...props} lineHeight={1}>
            <FontAwesomeIcon icon={props.icon} size={props.size} />
        </Box>
    );
});

// const Icon = forwardRef<HTMLElement, FontAwesomeIconProps>((props, ref) => {
//     return (
//         <FontAwesomeIcon {...props} ref={ref} />
//     );
// });

export default Icon;